import { SURVEY_TYPE, TEMPLATE_TYPE } from '../../config/EntityTypeList';

export const SURVEY_TYPE_COLLECTION_PATH = 'surveys';
export const TEMPLATE_TYPE_COLLECTION_PATH = 'templates';

export default {
  [SURVEY_TYPE]: SURVEY_TYPE_COLLECTION_PATH,
  [TEMPLATE_TYPE]: TEMPLATE_TYPE_COLLECTION_PATH,
};
